module.exports = __webpack_public_path__ + "static/media/Icons for EM-01.a0f70039.svg";